export default function generateTablePartDescription() {
    // We only support one table per sheet.
    return { count: '1', description: `<tablePart r:id="rId1"/>` };
}
